import Vue from 'vue'
import App from './App.vue'
import { MdField } from 'vue-material/dist/components'

import '../src/styles/main.scss';
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.use(MdField);

Vue.config.devtools = true;
Vue.config.debug = true;

new Vue({
  render: h => h(App),
}).$mount('#app')
